/*
  src/redux/callAPI.js

  Editted by Justin Chang on May 18, 2017
*/
import axios from 'axios';
import Promise from 'bluebird';

import { API_URL, UPDATE_LATENCY } from '../config';

// callAPI({
//   method:'GET',
//   path:'/foo',
//   begin:{
//     type:FOO_REQUESTED,
//   },
//   success:{
//     type:FOO_LOADED,
//     payload:(res) => res.data,
//     result:(res) => res.data
//   },
//   failure:{
//     type:FOO_FAILED_TO_LOAD
//   }
// })(dispatch, getState)


export default function callAPI(options){
  return (dispatch, getState) => {
    const token = getState().auth.token;
    const apiURL = API_URL + options.path;

    // Dispatch Begin
    if (options.begin) {
      dispatch({
        type:options.begin.type,
        payload:options.begin.payload()
      });
    }

    // Create Headers
    const headers = {
      'Content-Type': 'application/json; charset=UTF-8',
      'Accept': 'application/json'
    };
    if (token) headers['Authorization'] = `Bearer ${token}`;

    // Make API Call
    return axios({
      // transformRequest: [data => JSON.stringify(data)],
      url: apiURL,
      method: options.method || 'GET', // default to GET
      headers: options.headers || headers,
      data: (options.body) ? JSON.stringify(options.body) : null,
    })

    // Handle 404 error
    .catch(err => {
      if (err.response && err.response.status === 404 && options.allow404)
        return err.response;
      else
        throw err;
    })
    .then(res => ( res.data || {} ))

    // Optional - Delay results
    .then((result) => {
      return new Promise((resolve) => {
        if(!options.method || options.method === 'GET' || options.skipTimeout){
          resolve(result);
        } else {
          window.setTimeout( () => {
            resolve(result);
          }, UPDATE_LATENCY);
        }
      });
    })

    // Perform Success Action
    .then((res) => {
      // Dispatch Success
      if (options.success) {
        dispatch({
          type: options.success.type,
          payload: (options.success.payload) ? options.success.payload(res) : res
        });

        // Callbacks
        if(options.success.result){
          return options.success.result(res);
        }
      }

      return res;
    })

    // Perform Failure Action
    .catch((err) => {
      if (options.failure) {
        dispatch({
          type:options.failure.type,
          payload:err,
          error:true
        });
      }

      throw err;
    });
  }
}



// WEBPACK FOOTER //
// ./src/redux/callAPI.js